import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static outlets = ['modal'];

  // action="modal-opener#open"
  open(event) {
    event.preventDefault();
    this.modalOutlet.open();
  }
}
